module.exports = __webpack_public_path__ + "static/icon-Instagram-8fab12e82085e016ff2efd87baeddec8.png";